import {getAppLang, getCurrency, getProperty, getUserToken} from "../../../../utils";
import axios from "axios";
import {CPA_DAILY_PRICE, GET_CPA_COMPETITOR, SYNC_CPA_COMPETITOR, CPA_PROMOTION_AVAILABLE} from "../../../../constants/api.constants";

export function getPropertyCpa(){
    const requestOptions = {
        headers: { 'Content-Type': 'application/json',  'authToken': getUserToken(), 'language' : getAppLang()},
        body: {
            params: {
                property_id : getProperty(),
            }
        }
    };

    return dispatch => {
        dispatch({
            type: 'GET_CPA_COMPETITOR',
            payload: axios.post(GET_CPA_COMPETITOR, requestOptions.body, {headers: requestOptions.headers})
                .then(response => response.data.data)
        })
    }
}

export function getCpaDailyPrice(date, key, currency, property_id) {
    const body = {
        date: date,
        currency: currency ?? getCurrency(),
    };
    if (property_id !== undefined && property_id !== null) {
        body.property_id = property_id;
    }
    if (key !== undefined && key !== null) {
        body.competitor_property_key = key;
    }

    const requestOptions = {
        headers: {
            "Content-Type": "application/json",
            authToken: getUserToken(),
            language: getAppLang(),
        },
        body,
    };

     function delay(ms) {
        return new Promise((resolve) => {
           setTimeout(resolve, ms);
        })
     }

    return async (dispatch) => {
        const identifier = property_id !== undefined && property_id !== null
            ? `${property_id}_${date}`
            : `${key}_${date}`;
        dispatch({ type: "CPA_DAILY_PRICE_PENDING", payload: { identifier } });

        let attempts = 0;
        const maxAttempts = 5;
        let result = null;

        while (attempts < maxAttempts) {
            try {
                await delay(1000)
                const response = await axios.post(
                    CPA_DAILY_PRICE,
                    requestOptions.body,
                    { headers: requestOptions.headers }
                );

                const data = response.data.data;
                if (data?.amount !== null && data?.amount !== undefined) {
                    result = data;
                    break;
                }
            } catch (error) {
                console.error(`Error fetching data for ${identifier}:`, error);
            }
            attempts++;
        }

        if (result) {
            dispatch({ type: "CPA_DAILY_PRICE_FULFILLED", payload: { identifier, data: result } });
        } else {
            dispatch({ type: "CPA_DAILY_PRICE_REJECTED", payload: { identifier } });
        }
    };
}

export function getCpaPromotionAvailable(property_id, date) {
    const requestOptions = {
        headers: {
            'Content-Type': 'application/json',
            'authToken': getUserToken(),
            'language': getAppLang()
        },
        body: {
            params: {
                property_id,
                date
            }
        }
    };

    return dispatch => {
        dispatch({ type: 'CPA_PROMOTION_AVAILABLE_PENDING' });
        return axios.post(CPA_PROMOTION_AVAILABLE, requestOptions.body, { headers: requestOptions.headers })
            .then(response => {
                dispatch({
                    type: 'CPA_PROMOTION_AVAILABLE_FULFILLED',
                    payload: response.data.data
                });
            })
            .catch(error => {
                dispatch({
                    type: 'CPA_PROMOTION_AVAILABLE_REJECTED',
                    payload: error
                });
            });
    };
}

export function setSyncCpaCompetitor (data){
    const requestOptions = {
        headers: { 'Content-Type': 'application/json',  'authToken': getUserToken(), 'language' : getAppLang()},
        body: {
            params: {
                property_id: getProperty(),
                competitor: data.map(item => {
                    const mapped = {
                        id: item.id,
                        property_id: item.property_id,
                        name: item.name,
                        key: item.key,
                    };
                    // competitor_property_source varsa ekle
                    if (item.competitor_property_source) {
                        mapped.competitor_property_source = item.competitor_property_source;
                    }
                    return mapped;
                }),
            }
        }
    };

    return dispatch => {
        dispatch({
            type: 'SYNC_CPA_COMPETITOR',
            payload: axios.post(SYNC_CPA_COMPETITOR, requestOptions.body, {headers: requestOptions.headers})
                .then(response => response.data)
        })
    }
}

export function setSyncCpaCompetitorClearState() {
    return dispatch => {
        dispatch({
            type: 'SYNC_CPA_COMPETITOR_CLEAR_DATA',
        })
    }
}

export function getCpaClearState() {
    return dispatch => {
        dispatch({
            type: 'GET_CPA_COMPETITOR_CLEAR_DATA',
        })
    }
}